import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserListComponent } from '@root/components/user-managment/add-user/user-list/user-list.component';

@Component({
  selector: 'app-block-dialog',
  templateUrl: './block-dialog.component.html',
  styleUrls: ['./block-dialog.component.scss'],
})
export class BlockDialogComponent implements OnInit {

  name: string;

  isBlock:boolean;

  constructor(
    public dialogRef: MatDialogRef<UserListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.name = data.value.name;
    this.isBlock = data.isBlock;
  }

  ngOnInit() {}

  public onConfirmation() {
    const response = {'data': this.data};
    this.dialogRef.close(response);
  }
}
